export const getNotificationData = (data: any) => {
  if (data['type'] === 'order_placed') {
    return {
      body: 'pending_order_body',
      image_key: 'pending_order_image',
      link: data['link'],
    };
  } else if (data['type'] === 'order_updated') {
    return {
      body: `${data['order_status']}_order_body`,
      image_key: `${data['order_status']}_order_image`,
      link: data['link'],
    };
  } else if (data['type'] === 'coupon_received') {
    return {
      body: 'received_coupon_body',
      image_key: 'coupon_image',
      link: data['link'],
    };
  }
  return null;
};
